import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Observable } from 'rxjs/Observable';
import { ReservationStore } from '../../service/reservation-store';
import { DateRoomType } from '../../models/date-room-type';
import { DateRoomTypeNight } from '../../models/date-room-type-night';
import { List } from 'immutable';
import { RoomTypeNights } from '../../models/room-type-nights';
import { OverviewStore } from '../../service/overview.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pioneer-date-room-type-summary',
  templateUrl: './date-room-type-summary.component.html'
})
export class DateRoomTypeSummaryComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public dateRoomTypeDetail$: Observable<List<DateRoomTypeNight>>;
  public dateRoomTypeTotal$: Observable<List<RoomTypeNights>>;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(private overviewStore: OverviewStore,
              private translateService: TranslateService) {
  }

  ngOnInit() {

    this.dateRoomTypeDetail$ = this.overviewStore.dateStaySummary.map((dateRoomType: DateRoomType) => {
      return dateRoomType.dateRoomTypeNightDetail.dateRoomTypeNights;
    });

    this.dateRoomTypeTotal$ = this.overviewStore.dateStaySummary.map((dateRoomType: DateRoomType) => {
      return dateRoomType.dateRoomTypeNightTotal.nightsByRoomType;
    });
  }

  public translateUnknownRoomType(roomType: string): string {

    if ('UNKNOWN_ROOM_TYPE' === roomType) {
      return this.translateService.instant('EVENT.OVERVIEW_CARDS.UNKNOWN_ROOM_TYPE');
    } else {
      return roomType;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/overview/date-room-type-summary/date-room-type-summary.component.ts